export const galleryList = [
  {
    imgSrc: require('@/assets/images/galleryImgs/1.jpg'),
    desc: '家谱续修',
    path: ''
  },
  {
    imgSrc: require('@/assets/images/galleryImgs/2.jpg'),
    desc: '族谱印刷',
    path: ''
  },
  {
    imgSrc: require('@/assets/images/galleryImgs/3.jpg'),
    desc: 'VR纪念馆',
    path: ''
  },
  {
    imgSrc: require('@/assets/images/galleryImgs/4.jpg'),
    desc: '智慧宗祠',
    path: ''
  },
  {
    imgSrc: require('@/assets/images/galleryImgs/5.jpg'),
    desc: '寻根问祖',
    path: ''
  },
  {
    imgSrc: require('@/assets/images/galleryImgs/6.jpg'),
    desc: '家庭名录',
    path: ''
  },
  {
    imgSrc: require('@/assets/images/galleryImgs/7.jpg'),
    desc: '族事记要',
    path: ''
  },
  {
    imgSrc: require('@/assets/images/galleryImgs/8.jpg'),
    desc: '百家姓氏',
    path: ''
  }
]
